module.exports = __webpack_public_path__ + "img/unitTest@2x.bc0ea1a5.png";